module.exports = __webpack_public_path__ + "static/media/oldbell.45902bd3.mp3";